export enum ENotificationTest
{
  Email = 0,
  Exception = 1,
  Diagnostics = 2,
  Temperature = 3
}